import { ContactFilterInput } from '../gql/graphql';
import { graphql } from '../gql';
import { useMemo } from 'react';
import { useQuery } from '@apollo/client';

export const CHECK_DUPLICATE_EMAIL = graphql(`
  query checkDuplicateEmail($filters: ContactFilterInput) {
    checkDuplicateEmail(filters: $filters)
  }
`);

export function useCheckDuplicateEmail({
  filters,
  enabled = true,
}: {
  filters?: ContactFilterInput;
  enabled?: boolean;
}) {
  const skipQuery = !enabled || !filters;

  const { loading, error, data, refetch } = useQuery(CHECK_DUPLICATE_EMAIL, {
    variables: { filters },
    skip: skipQuery,
  });

  const { checkDuplicateEmail } = useMemo(() => {
    return {
      checkDuplicateEmail: data?.checkDuplicateEmail,
    };
  }, [data]);

  return {
    error,
    loading,
    checkDuplicateEmail,
    refetch,
  };
}
